/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import ClayCard from './Card';
import {ClayCardWithHorizontal} from './CardWithHorizontal';
import {ClayCardWithInfo} from './CardWithInfo';
import {ClayCardWithNavigation} from './CardWithNavigation';
import {ClayCardWithUser} from './CardWithUser';

export {
	ClayCardWithInfo,
	ClayCardWithHorizontal,
	ClayCardWithNavigation,
	ClayCardWithUser,
};

export default ClayCard;
